export default function financial(x, hasDecimals = true, scale = null) {
    const fractionDigits = scale !== null ? scale : (hasDecimals ? 2 : 0);
    const euroFormat = Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
    if (isNaN(x) || x === '') {
        return '0 €';
    }
    return euroFormat.format(Number.parseFloat(x).toFixed(fractionDigits));
};
